var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E0E1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 19.5H37.75C38.4793 19.5 39.1788 19.7897 39.6945 20.3055C40.2103 20.8212 40.5 21.5207 40.5 22.25V41.5C40.5 42.2293 40.2103 42.9288 39.6945 43.4445C39.1788 43.9603 38.4793 44.25 37.75 44.25H21.25C20.5207 44.25 19.8212 43.9603 19.3055 43.4445C18.7897 42.9288 18.5 42.2293 18.5 41.5V22.25C18.5 21.5207 18.7897 20.8212 19.3055 20.3055C19.8212 19.7897 20.5207 19.5 21.25 19.5H24",
    stroke: "#2C357D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.625 16.75H25.375C24.6156 16.75 24 17.3656 24 18.125V20.875C24 21.6344 24.6156 22.25 25.375 22.25H33.625C34.3844 22.25 35 21.6344 35 20.875V18.125C35 17.3656 34.3844 16.75 33.625 16.75Z",
    stroke: "#2C357D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqUser);
export default __webpack_public_path__ + "static/media/req_user.faedb8625960e43bc133a2e901787e28.svg";
export { ForwardRef as ReactComponent };